export default __webpack_public_path__ + "static/media/footer.b63b1312.svg";